import { useQuery } from '@tanstack/react-query';
import { useUser } from '@clerk/clerk-react';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook to get the current user's profile ID from the database
 * This maps Clerk user ID to the user_profiles.id UUID
 */
export function useUserProfile() {
  const { user } = useUser();
  const clerkUserId = user?.id;

  const { data: profile, isLoading, error } = useQuery({
    queryKey: ['user-profile', clerkUserId],
    queryFn: async () => {
      if (!clerkUserId) {
        throw new Error('No Clerk user ID available');
      }

      const { data, error } = await supabase
        .from('user_profiles')
        .select('id, clerk_user_id, email')
        .eq('clerk_user_id', clerkUserId)
        .single();

      if (error) {
        console.error('[useUserProfile] Error fetching profile:', error);
        throw error;
      }

      if (!data) {
        throw new Error('User profile not found');
      }

      return data;
    },
    enabled: !!clerkUserId,
    staleTime: 5 * 60 * 1000, // 5 minutes - profile data rarely changes
  });

  return {
    userProfileId: profile?.id,
    clerkUserId,
    profile,
    isLoading,
    error,
  };
}
